import { Box, SxProps, Typography } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { dayjs } from "@outschool/time";
import { useSession } from "@outschool/ui-auth";
import groupBy from "lodash/groupBy";
import React from "react";

import { UpcomingClassesQuery } from "../../../../../../shared/generated/graphql";
import { UpcomingClass } from "./UpcomingClass";
import {
  NormalizedEventInfo,
  extractAndNormalizeFlexSectionAndMeetingData
} from "./UpcomingClassesHelper";

const getOccuranceDay = (event: NormalizedEventInfo) =>
  dayjs(event.start).startOf("day").format();

type UpcomingClassesProps = {
  // @ts-ignore TS(2339): Property 'leader' does not exist on type '{ __type... Remove this comment to see the full error message
  leaderData: UpcomingClassesQuery["publicProfile"]["leader"];
};

export const UpcomingClasses: React.FunctionComponent<UpcomingClassesProps> = ({
  leaderData
}) => {
  const classes = extractAndNormalizeFlexSectionAndMeetingData(leaderData);

  const classesGroupedByDate = groupBy(classes, getOccuranceDay);

  const daysForUpcomingClasses = Object.keys(classesGroupedByDate).sort();

  return (
    <>
      {daysForUpcomingClasses.map((day, idx) => {
        const classes = classesGroupedByDate[day];

        return (
          <Box key={day}>
            <FormattedDate
              day={day}
              sx={{ paddingTop: idx === 0 ? "24px" : "32px" }}
            />

            {classes.map(c => (
              <UpcomingClass key={c.section.uid} {...c} />
            ))}
          </Box>
        );
      })}
    </>
  );
};

type FormattedDateProps = {
  day: string;
  sx?: SxProps;
};

export const FormattedDate: React.FunctionComponent<FormattedDateProps> = ({
  day,
  sx
}) => {
  const { userTimeZone } = useSession();

  const formattedDate = dayjs
    // @ts-ignore TS(2769): No overload matches this call.
    .tz(dayjs(day), userTimeZone)
    .format("ddd., MMM D");

  return (
    <Typography
      variant="inherit"
      sx={[
        {
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: "600",
          display: "block"
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      {formattedDate}
    </Typography>
  );
};
